module.exports = __webpack_public_path__ + "img/28b4e40.svg";